import { createSlice } from '@reduxjs/toolkit';
import { DEFAULT_LIMIT, DEFAULT_PAGE } from '../../../consts';

const slice = createSlice({
    name: 'assignTrip',
    initialState: {
        isRequesting: false,
        error: null,
        isDone: false,
        data: null,
        dataTongDa: [],
        isSync: false,
        dataHistory: {
            data: [],
            total: 0,
            searchCriteria: {
                page: DEFAULT_PAGE,
                size: DEFAULT_LIMIT,
            },
        },
    },
    reducers: {
        assign_trip: (state) => {
            return {
                ...state,
                isRequesting: true,
                isDone: false,
                error: null,
            };
        },
        assign_trip_failed: (state, action) => {
            return {
                ...state,
                isRequesting: false,
                isDone: true,
                error: action.payload,
                data: null,
            };
        },
        assign_trip_succeed: (state) => {
            return {
                ...state,
                isRequesting: false,
                error: null,
                isDone: true,
            };
        },
        assign_multi_trip: (state) => {
            return {
                ...state,
                isRequesting: true,
                isDone: false,
                error: null,
            };
        },
        assign_multi_trip_failed: (state, action) => {
            return {
                ...state,
                isRequesting: false,
                isDone: true,
                error: action.payload,
                data: null,
            };
        },
        assign_multi_trip_succeed: (state) => {
            return {
                ...state,
                isRequesting: false,
                error: null,
                isDone: true,
            };
        },
        copy_assign_trip: (state) => {
            return {
                ...state,
                isRequesting: true,
                isDone: false,
                error: null,
            };
        },
        copy_assign_trip_failed: (state, action) => {
            return {
                ...state,
                isRequesting: false,
                isDone: true,
                error: action.payload,
                data: null,
            };
        },
        copy_assign_trip_succeed: (state) => {
            return {
                ...state,
                isRequesting: false,
                error: null,
                isDone: true,
            };
        },
        update_assign_trip: (state) => {
            return {
                ...state,
                isRequesting: true,
                isDone: false,
                error: null,
            };
        },
        update_assign_trip_failed: (state, action) => {
            return {
                ...state,
                isRequesting: false,
                isDone: true,
                error: action.payload,
                data: null,
            };
        },
        update_assign_trip_succeed: (state) => {
            return {
                ...state,
                isRequesting: false,
                error: null,
                isDone: true,
            };
        },
        delete_assign_trip: (state) => {
            return {
                ...state,
                isRequesting: true,
                isDone: false,
                error: null,
            };
        },
        delete_assign_trip_failed: (state, action) => {
            return {
                ...state,
                isRequesting: false,
                isDone: true,
                error: action.payload,
                data: null,
            };
        },
        delete_assign_trip_succeed: (state) => {
            return {
                ...state,
                isRequesting: false,
                error: null,
                isDone: true,
            };
        },
        update_status_assign_trip: (state) => {
            return {
                ...state,
                isRequesting: true,
                isDone: false,
                error: null,
            };
        },
        update_status_assign_trip_failed: (state, action) => {
            return {
                ...state,
                isRequesting: false,
                isDone: true,
                error: action.payload,
                data: null,
            };
        },
        update_status_assign_trip_succeed: (state) => {
            return {
                ...state,
                isRequesting: false,
                error: null,
                isDone: true,
            };
        },

        delete_assign_trip_multiple: (state) => {
            return {
                ...state,
                isRequesting: true,
                isDone: false,
                error: null,
            };
        },
        delete_assign_trip_multiple_failed: (state, action) => {
            return {
                ...state,
                isRequesting: false,
                isDone: true,
                error: action.payload,
                data: null,
            };
        },
        delete_assign_trip_multiple_succeed: (state) => {
            return {
                ...state,
                isRequesting: false,
                error: null,
                isDone: true,
            };
        },
        get_tong_da_preview: (state) => {
            return {
                ...state,
                isRequesting: true,
                error: null,
                isDone: true,
            };
        },
        get_tong_da_preview_success: (state, action) => {
            return {
                ...state,
                isRequesting: false,
                error: null,
                isDone: true,
                dataTongDa: action.payload?.dataTongDa,
            };
        },
        get_tong_da_preview_fail: (state, action) => {
            return {
                ...state,
                isRequesting: false,
                error: action.payload,
                isDone: true,
                dataTongDa: [],
            };
        },
        sync_tong_da: (state) => {
            return {
                ...state,
                isRequesting: true,
                isDone: true,
                isSync: false,
            };
        },
        sync_tong_da_success: (state, action) => {
            return {
                ...state,
                isRequesting: false,
                error: null,
                isDone: true,
                isSync: true,
            };
        },
        sync_tong_da_fail: (state, action) => {
            return {
                ...state,
                isRequesting: false,
                error: action.payload,
                isDone: true,
                isSync: true,
            };
        },
        get_assignment_history: (state) => {
            return {
                ...state,
                isRequesting: true,
                error: null,
                isDone: true,
            };
        },
        get_assignment_history_success: (state, action) => {
            return {
                ...state,
                isRequesting: false,
                error: null,
                isDone: true,
                dataHistory: {
                    data: action?.payload?.dataHistory,
                    total: action?.payload?.total,
                    searchCriteria: action?.payload?.searchCriteria,
                },
            };
        },
        get_assignment_history_fail: (state, action) => {
            return {
                ...state,
                isRequesting: false,
                error: null,
                isDone: true,
                dataHistory: {
                    data: [],
                    total: 0,
                },
            };
        },
        edit_muti_trip: (state) => {
            return {
                ...state,
                isRequesting: true,
                error: null,
                isDone: true,
            };
        },
        edit_muti_trip_success: (state, action) => {
            return {
                ...state,
                isRequesting: false,
                error: null,
                isDone: true,
            };
        },
        edit_muti_trip_fail: (state, action) => {
            return {
                ...state,
                isRequesting: false,
                error: null,
                isDone: true,
            };
        },
    },
});

export const { reducer, actions } = slice;

export default reducer;
